<template>
  <div class="car-mileage">
    <div
      class="standard-input-container"
      :class="{ 'focus': labelFocus || hasValue }"
    >
      <label
        class="standard-input-label"
      >
        Przebieg samochodu (km)
      </label>
      <div class="standard-input-wrapper">
        <input
          ref="mileage"
          type="text"
          class="standard-input"
          v-model="mileage"
          @keyup.enter="!disableButton ? onClick() : null"
          @input="onInput()"
          @focus="onFocus()"
          @blur="onBlur()"
          maxlength="7"
        >
      </div>
    </div>
    <standard-button
      custom-class="car-mileage-button"
      text="Dalej"
      @buttonClick="onClick()"
      :disabled="disableButton"
      :background-color="buttonColor"
      color="white"
    />
  </div>
</template>

<script>
import StandardButton from '~/StandardButton';
import { mapGetters, mapActions } from 'vuex';
import isNumber from 'lodash/isNumber';

export default {
  components: {
    StandardButton,
  },
  data() {
    return {
      mileage: '',
      labelFocus: false,
    };
  },
  computed: {
    ...mapGetters({
      buttonColor: 'brand/getThirdColor',
      actualMileage: 'visit/mileage',
    }),
    disableButton() {
      return !this.mileage;
    },
    hasValue() {
      return !!this.mileage;
    },
  },
  methods: {
    ...mapActions({
      closeModal: 'modal/closeModal',
      setMileage: 'visit/setMileage',
    }),
    onClick() {
      this.closeModal();
      this.setMileage(this.mileage);
    },
    onInput() {
      this.labelFocus = true;
    },
    onBlur() {
      this.labelFocus = false;
    },
    onFocus() {
      this.labelFocus = true;
    },
  },
  watch: {
    mileage() {
      const inputValue = parseInt(this.mileage, 10);
      if (isNumber(inputValue) && !isNaN(inputValue)) {
        this.mileage = inputValue;
      } else {
        this.mileage = '';
      }
    },
  },
  mounted() {
    this.$refs.mileage.focus();

    if (this.actualMileage > 0) {
      this.mileage = this.actualMileage;
    }
  },
};
</script>
